import { render, staticRenderFns } from "./CardReadingLevel.vue?vue&type=template&id=37060fb4&scoped=true&"
import script from "./CardReadingLevel.vue?vue&type=script&lang=js&"
export * from "./CardReadingLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37060fb4",
  null
  
)

export default component.exports